/* GEC Remix — swap product-card image (and link) when a variant/flavor is chosen.
   Delegated so it covers every .gec-pcard rendered anywhere on the site. */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('.gec-pcard__select')) return;

    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    var card = sel.closest('.gec-pcard');
    if (!card) return;

    // Swap the card image to the selected variant's image (if it has one).
    var img = card.querySelector('.gec-pcard__media img');
    var newSrc = opt.getAttribute('data-img');
    if (img && newSrc) {
      img.removeAttribute('srcset'); // let src win over the responsive srcset
      img.src = newSrc;
    }

    // Keep the click-through link pointed at the selected variant.
    var link = card.querySelector('a.gec-pcard__media');
    var url = opt.getAttribute('data-url');
    if (link && url) link.setAttribute('href', url);
  });
})();
